

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface WarehouseMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface WarehouseMst {
    id?:number;
    warehouseCode:string;
    warehouseName:string;
    warehouseShortname:string;
    warehouseAddress1:string;
    warehouseAddress2:string;
    warehouseCity:string;
    warehousePincode:string;
    warehouseCountry:string;
    warehouseActiveFlag:string;
    warehousePrimaryFlag:string;
   country?:any;
    createdIp:string;
 
    createdBy:number;
    createdDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: WarehouseMstParameter[];
    links?: any;
}

export abstract class WarehouseMstData { 
    abstract list(url: string): Observable<WarehouseMst[]>;
    abstract create(url: string,data: WarehouseMst): Observable<any>;
    abstract update(url: string,data: WarehouseMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
